export const PAYMENT_TERM_OPTIONS = [
    { value: 'cod', label: 'COD', days: 0 },
    { value: '7_days', label: '7 Days', days: 7 },
    { value: '14_days', label: '14 Days', days: 14 },
    { value: '21_days', label: '21 Days', days: 21 },
    { value: '28_days', label: '28 Days', days: 28 },
    { value: '30_days', label: '30 Days', days: 30 },
    { value: '45_days', label: '45 Days', days: 45 },
    { value: '60_days', label: '60 Days', days: 60 },
];

export const EARLY_PAYMENT_OPTIONS = [
    { value: '3_days', label: 'COD', days: 0 },
    { value: '7_days', label: '7 Days', days: 7 },
    { value: '14_days', label: '14 Days', days: 14 },
    { value: '21_days', label: '21 Days', days: 21 },
    { value: '28_days', label: '28 Days', days: 28 },
    { value: '30_days', label: '30 Days', days: 30 },
    { value: '45_days', label: '45 Days', days: 45 },
    { value: 'not_needed', label: '60 Days', days: 60 },
];

export const getPaymentTermDays = (paymentTerm) => {
    const option = PAYMENT_TERM_OPTIONS.find((opt) => opt.value === paymentTerm);
    return option ? option.days : 0;
};

export const getPaymentTermLabel = (paymentTerm) => {
    const option = PAYMENT_TERM_OPTIONS.find((opt) => opt.value === paymentTerm);
    return option ? option.label : paymentTerm;
};

export const getFilteredEarlyPaymentOptions = (paymentTerm) => {
    const ptDays = getPaymentTermDays(paymentTerm);

    return EARLY_PAYMENT_OPTIONS.filter(
        (opt) => opt.days <= ptDays && (opt.value !== '28_days' || paymentTerm === '28_days'),
    );
};

export const getDefaultEarlyPaymentForPaymentTerm = (_paymentTerm) => {
    // Finance / early payment option defaults to COD regardless of payment term
    return '3_days';
};

export const isEarlyPaymentValid = (paymentTerm, earlyPaymentValue) => {
    const filtered = getFilteredEarlyPaymentOptions(paymentTerm);
    return filtered.some((opt) => opt.value === earlyPaymentValue);
};

export const getEarlyPaymentDays = (earlyPaymentValue) => {
    if (earlyPaymentValue === '3_days') return 0;
    const option = EARLY_PAYMENT_OPTIONS.find((opt) => opt.value === earlyPaymentValue);
    return option ? option.days : 0;
};

export const COD_EARLY_PAYMENT_TOOLTIP =
    'Trade margin fee will be calculated for (T–1) days when trade support is selected as COD, instead of the full payment term (T).';

export const mapEarlyPaymentFromApi = (apiValue) => {
    if (!apiValue) return '';
    if (apiValue === 'cod') return '3_days';
    return apiValue;
};

export const isFullTermEarlyPaymentOption = (paymentTerm, optionValue) => {
    return (
        optionValue === 'not_needed' ||
        (paymentTerm === optionValue && ['28_days', '45_days', '60_days'].includes(optionValue))
    );
};
